module.exports = __webpack_public_path__ + "img/close-ticket.9c798a1d.svg";